import component from './commonheader.component.js';
export default angular.module('commonheader', [])
	.component('commonheader', component);



// WEBPACK FOOTER //
// ./example/app/common/commonheader/commonheader.js